import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SelectRatingPage } from './select-rating';

@NgModule({
  declarations: [
    SelectRatingPage,
  ],
  imports: [
    IonicPageModule.forChild(SelectRatingPage),
  ],
})
export class SelectRatingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/select-rating/select-rating.module.ts